<div>
  <h1 class="page-title">Zahlungsabgleich</h1>
</div>

<div
  class="offcanvas offcanvas-end"
  data-bs-backdrop="default"
  tabindex="-1"
  id="staticBackdrop"
  aria-labelledby="staticBackdropLabel">
  <div class="offcanvas-header">
    <h1 class="offcanvas-title" id="staticBackdropLabel">Zahlung bearbeiten {{ current_aktenzeichen }}</h1>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Schließen">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
  <div class="offcanvas-body">
    <router-outlet></router-outlet>
  </div>
</div>

<div class="container-fluid" style="margin-top: 20px">
  <!-- Kopfbereich: links Kennzahlen (50%), rechts Import-Dropzone (50%) -->
  <div class="mb-4 flex flex-col gap-4 lg:flex-row">
    <!-- Kennzahlen -->
    <div class="flex gap-3 lg:w-1/2">
      <div class="flex-1 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
        <div class="text-xs font-medium uppercase tracking-wide text-amber-700">Offen</div>
        <div class="text-2xl font-semibold text-amber-900">{{ summary.total_offen }}</div>
      </div>
      <div class="flex-1 rounded-lg border border-green-200 bg-green-50 px-4 py-3">
        <div class="text-xs font-medium uppercase tracking-wide text-green-700">Abgeschlossen</div>
        <div class="text-2xl font-semibold text-green-900">{{ summary.total_abgeschlossen }}</div>
      </div>
      <div class="flex-1 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
        <div class="text-xs font-medium uppercase tracking-wide text-red-700">Probleme</div>
        <div class="text-2xl font-semibold text-red-900">{{ summary.total_probleme }}</div>
      </div>
    </div>

    <!-- Import-Dropzone -->
    <div class="lg:w-1/2">
      <div
        class="import-dropzone h-full"
        [class.active]="dropActive"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        <div class="import-dropzone-inner">
          <i class="fas fa-cloud-upload-alt fa-2x mb-2"></i>
          <p class="mb-2">Bankdatei hier ablegen (.dat, .xml, .zip) – oder auswählen</p>
          <div class="flex flex-wrap justify-center gap-2">
            <label class="btn btn-primary mb-0">
              <i class="fas fa-folder-open"></i> Datei wählen
              <input type="file" accept=".dat,.xml,.zip" multiple (change)="onFileSelected($event)" hidden />
            </label>
            <button type="button" class="btn btn-outline-primary" (click)="syncFolder()" [disabled]="isLoading">
              <i class="fas fa-sync"></i> Ordner synchronisieren
            </button>
          </div>
          <p class="mt-2 text-xs text-gray-400">
            <i class="fas fa-magic"></i> Neue Zahlungen werden nach dem Import automatisch zugeordnet.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Tab-Navigation (horizontal zentriert) -->
  <div class="mt-8 mb-6 flex justify-center">
    <div class="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-1">
      <button
        type="button"
        class="rounded-md px-4 py-2 text-sm font-medium transition"
        [ngClass]="activeTab === 'import' ? 'bg-blue-600 text-white shadow' : 'text-gray-600 hover:text-gray-900'"
        (click)="setTab('import')">
        <i class="fas fa-cloud-upload-alt me-1"></i> offene Zahlungen
      </button>
      <button
        type="button"
        class="rounded-md px-4 py-2 text-sm font-medium transition"
        [ngClass]="activeTab === 'zahlungen' ? 'bg-blue-600 text-white shadow' : 'text-gray-600 hover:text-gray-900'"
        (click)="setTab('zahlungen')">
        <i class="fas fa-list me-1"></i> abgeschlossene Zahlungen
      </button>
    </div>
  </div>

  <!-- TAB: Import & offene Zahlungen -->
  <div *ngIf="activeTab === 'import'">
    <p class="text-sm text-gray-500">Hier sehen Sie alle offenen bzw. noch nicht zugeordneten Zahlungen.</p>
  </div>

  <!-- TAB: Zahlungen (alle mit Status ungleich offen) -->
  <div *ngIf="activeTab === 'zahlungen'">
    <!-- Tailwind-Filter -->
    <div class="mb-4 rounded-lg border border-gray-200 bg-white">
      <button
        type="button"
        class="flex w-full items-center justify-between px-4 py-3 text-left font-semibold text-gray-700"
        (click)="toggleFilter()">
        <span><i class="fas fa-filter me-1"></i> Filter</span>
        <svg class="h-4 w-4 transition-transform" [class.rotate-180]="isFilterExpanded" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
      <div class="border-t border-gray-100 px-4 py-4" [class.hidden]="!isFilterExpanded">
        <form [formGroup]="filterForm">
          <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Von Datum</label>
              <div class="relative">
                <input
                  [matDatepicker]="pickerFrom"
                  formControlName="dateFrom"
                  (dateChange)="onFilterChange()"
                  readonly
                  (click)="pickerFrom.open()"
                  placeholder="TT.MM.JJJJ"
                  class="block w-full cursor-pointer rounded-md border border-gray-300 px-3 py-2 pr-9 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
                <button type="button" (click)="pickerFrom.open()"
                  class="absolute inset-y-0 right-0 flex items-center pr-2.5 text-gray-400 hover:text-gray-600">
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                  </svg>
                </button>
                <mat-datepicker #pickerFrom></mat-datepicker>
              </div>
            </div>
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Bis Datum</label>
              <div class="relative">
                <input
                  [matDatepicker]="pickerTo"
                  formControlName="dateTo"
                  (dateChange)="onFilterChange()"
                  readonly
                  (click)="pickerTo.open()"
                  placeholder="TT.MM.JJJJ"
                  class="block w-full cursor-pointer rounded-md border border-gray-300 px-3 py-2 pr-9 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
                <button type="button" (click)="pickerTo.open()"
                  class="absolute inset-y-0 right-0 flex items-center pr-2.5 text-gray-400 hover:text-gray-600">
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                  </svg>
                </button>
                <mat-datepicker #pickerTo></mat-datepicker>
              </div>
            </div>
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Zahlungsstatus</label>
              <div class="relative" (click)="$event.stopPropagation()">
                <button type="button" (click)="toggleStatusDropdown('payment')"
                  class="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                  <span class="truncate">{{ statusSummaryLabel('paymentStatus', paymentStatusOptions) }}</span>
                  <svg class="ml-2 h-4 w-4 shrink-0 text-gray-400 transition-transform" [class.rotate-180]="openStatusDropdown === 'payment'"
                    fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
                <div *ngIf="openStatusDropdown === 'payment'"
                  class="absolute z-30 mt-1 max-h-60 w-full overflow-auto rounded-md border border-gray-200 bg-white py-1 shadow-lg">
                  <label *ngFor="let status of paymentStatusOptions"
                    class="flex cursor-pointer items-center gap-2 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
                    <input type="checkbox" [checked]="isStatusSelected('paymentStatus', status.value)"
                      (change)="toggleStatusValue('paymentStatus', status.value)"
                      class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                    <span>{{ status.label }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Abgleichstatus</label>
              <div class="relative" (click)="$event.stopPropagation()">
                <button type="button" (click)="toggleStatusDropdown('reconciliation')"
                  class="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                  <span class="truncate">{{ statusSummaryLabel('reconciliationStatus', reconciliationStatusOptions) }}</span>
                  <svg class="ml-2 h-4 w-4 shrink-0 text-gray-400 transition-transform" [class.rotate-180]="openStatusDropdown === 'reconciliation'"
                    fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
                <div *ngIf="openStatusDropdown === 'reconciliation'"
                  class="absolute z-30 mt-1 max-h-60 w-full overflow-auto rounded-md border border-gray-200 bg-white py-1 shadow-lg">
                  <label *ngFor="let status of reconciliationStatusOptions"
                    class="flex cursor-pointer items-center gap-2 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
                    <input type="checkbox" [checked]="isStatusSelected('reconciliationStatus', status.value)"
                      (change)="toggleStatusValue('reconciliationStatus', status.value)"
                      class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                    <span>{{ status.label }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Mindestbetrag</label>
              <input type="number" formControlName="amountMin" (change)="onFilterChange()"
                class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Höchstbetrag</label>
              <input type="number" formControlName="amountMax" (change)="onFilterChange()"
                class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Einzahler</label>
              <input type="text" formControlName="debtorName" (change)="onFilterChange()"
                class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
            <div>
              <label class="mb-1 block text-sm font-medium text-gray-700">Aktenzeichen</label>
              <input type="text" formControlName="aktenzeichen" (change)="onFilterChange()"
                class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
          </div>
          <div class="mt-4">
            <button type="button"
              class="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              (click)="clearFilters()">
              <i class="fas fa-undo"></i> Filter zurücksetzen
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Aktionen -->
    <div class="mb-4 flex flex-wrap items-center gap-2">
      <button type="button" class="btn btn-outline-success" (click)="exportData()">
        <i class="fas fa-download"></i> Exportieren
      </button>
      <button type="button" class="btn btn-outline-primary" (click)="openReportDialog()">
        <i class="fas fa-file-pdf"></i> Bericht erstellen
      </button>
    </div>
  </div>

  <!-- Gemeinsame Tabelle (Daten je nach Tab gefiltert) -->
  <div class="mx-1">
    <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; background: white">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>

    <div class="mb-2 flex items-center justify-between gap-3">
      <div class="relative w-full max-w-sm">
        <input
          type="text"
          (keyup)="applyFilter($event)"
          [(ngModel)]="searchValue"
          placeholder="Suche …"
          class="block w-full rounded-md border border-gray-300 px-3 py-2 pr-9 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
        <button
          *ngIf="searchValue"
          type="button"
          class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
          (click)="searchValue = ''; pageIndex = 0; loadData()">
          <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <span class="whitespace-nowrap text-sm text-gray-500">Gesamt: {{ totalCount }} Zahlungen</span>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        <!-- Valuta Datum Column -->
        <ng-container matColumnDef="valuta_datum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Valuta-Datum</th>
          <td mat-cell *matCellDef="let element">{{ formatDate(element.valuta_datum) }}</td>
        </ng-container>

        <!-- Betrag Column -->
        <ng-container matColumnDef="betrag">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Betrag</th>
          <td mat-cell *matCellDef="let element">
            <span class="fw-bold">{{ formatCurrency(element.betrag) }}</span>
          </td>
        </ng-container>

        <!-- Debtor Name Column -->
        <ng-container matColumnDef="debtor_name">
          <th mat-header-cell *matHeaderCellDef>Einzahler</th>
          <td mat-cell *matCellDef="let element">{{ element.debtor_name }}</td>
        </ng-container>

        <!-- Creditor Reference Column -->
        <ng-container matColumnDef="creditor_reference">
          <th mat-header-cell *matHeaderCellDef>Referenz</th>
          <td mat-cell *matCellDef="let element">{{ element.creditor_reference }}</td>
        </ng-container>

        <!-- Aktenzeichen Column -->
        <ng-container matColumnDef="aktenzeichen">
          <th mat-header-cell *matHeaderCellDef>Aktenzeichen</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.aktenzeichen" class="badge bg-info">{{ element.aktenzeichen }}</span>
            <span *ngIf="!element.aktenzeichen" class="text-muted">Nicht zugeordnet</span>
          </td>
        </ng-container>

        <!-- Mandat Betrag Faellig Column -->
        <ng-container matColumnDef="mandat_betrag_faellig">
          <th mat-header-cell *matHeaderCellDef>Mandat-Betrag</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.mandat_betrag_faellig">{{ formatCurrency(element.mandat_betrag_faellig) }}</span>
            <span *ngIf="!element.mandat_betrag_faellig" class="text-muted">-</span>
          </td>
        </ng-container>

        <!-- Betrag Differenz Column -->
        <ng-container matColumnDef="betrag_differenz">
          <th mat-header-cell *matHeaderCellDef>Differenz</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.betrag_differenz !== null"
                  [class]="element.betrag_differenz > 0 ? 'text-success' : element.betrag_differenz < 0 ? 'text-danger' : 'text-muted'">
              {{ formatCurrency(element.betrag_differenz) }}
            </span>
            <span *ngIf="element.betrag_differenz === null" class="text-muted">-</span>
          </td>
        </ng-container>

        <!-- Payment Status Column -->
        <ng-container matColumnDef="payment_status">
          <th mat-header-cell *matHeaderCellDef>Zahlungsstatus</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge" [class]="getPaymentStatusClass(element.payment_status)">
              {{ getPaymentStatusLabel(element.payment_status) }}
            </span>
          </td>
        </ng-container>

        <!-- Reconciliation Status Column -->
        <ng-container matColumnDef="reconciliation_status">
          <th mat-header-cell *matHeaderCellDef>Abgleichstatus</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge" [class]="getReconciliationStatusClass(element.reconciliation_status)">
              {{ getReconciliationStatusLabel(element.reconciliation_status) }}
            </span>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Aktionen</th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="editZahlung(element)"
                      title="Bearbeiten">
                <i class="fas fa-edit me-1"></i>Bearbeiten
              </button>
              <button type="button" class="btn btn-sm btn-outline-success" (click)="reconcileZahlung(element)"
                      *ngIf="element.reconciliation_status !== 'A'" title="Abgleichen">
                <i class="fas fa-check me-1"></i>Abgleichen
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            class="cursor-pointer hover:bg-blue-50"
            (click)="editZahlung(row)"></tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50, 100]"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>

    <!-- Status-Legende (Akkordeon: nur auf Klick sichtbar) -->
    <div class="mt-6 rounded-lg border border-gray-200 bg-white">
      <button
        type="button"
        class="flex w-full items-center justify-between px-4 py-3 text-left text-sm font-semibold text-gray-700"
        (click)="isLegendExpanded = !isLegendExpanded">
        <span>Legende der Status</span>
        <svg class="h-4 w-4 transition-transform" [class.rotate-180]="isLegendExpanded" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
      <div class="border-t border-gray-100 px-4 py-4" [class.hidden]="!isLegendExpanded">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-2">
          <div>
            <div class="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Zahlungsstatus</div>
            <table class="w-full text-sm">
              <tbody>
                <tr *ngFor="let s of paymentStatusOptions" class="border-b border-gray-100 last:border-0">
                  <td class="py-1.5 pr-3 align-top whitespace-nowrap">
                    <span class="badge" [ngClass]="getPaymentStatusClass(s.value)">{{ s.label }}</span>
                  </td>
                  <td class="py-1.5 align-top text-gray-600">{{ s.description }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <div class="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Abgleichstatus</div>
            <table class="w-full text-sm">
              <tbody>
                <tr *ngFor="let s of reconciliationStatusOptions" class="border-b border-gray-100 last:border-0">
                  <td class="py-1.5 pr-3 align-top whitespace-nowrap">
                    <span class="badge" [ngClass]="getReconciliationStatusClass(s.value)">{{ s.label }}</span>
                  </td>
                  <td class="py-1.5 align-top text-gray-600">{{ s.description }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
